export default __webpack_public_path__ + "static/media/home2.7a437476.png";